import React from 'react';
import { Box, BoxProps, useTheme } from '@mui/material';
import { useContext } from 'react';
import { UiContext } from 'shared/lib/contexts/uiContext';
import IconFolder from 'shared/icons/iconFolder';
import CellContainer from 'shared/lib/extendedComponents/grids/components/cellContainer';
import { makeTransition } from 'shared/lib/utils/utils';
import { GridRowContext } from 'shared/lib/extendedComponents/grids/components/gridRowContainer';
import LimitedTypography from 'shared/lib/components/text/limitedTypography';

const clamp = 2;

export default function DesktopFolderNameCell({
  name,
  onClick,
  overrideColor,
}: {
  name: string;
  onClick?: () => void;
  overrideColor?: string;
} & BoxProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);
  const theme = useTheme();
  const { isHover } = useContext(GridRowContext);

  const color = isHover
    ? theme.palette.primary.main
    : overrideColor || theme.palette.text.primary;

  return (
    <CellContainer onClick={onClick}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: sp.s30,
          overflow: 'hidden',
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          <IconFolder></IconFolder>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: sp.s20,
          }}
        >
          <LimitedTypography
            variant="f20b"
            clamp={clamp}
            sx={{
              color,
              transition: makeTransition(['color']),
            }}
          >
            {name}
          </LimitedTypography>
        </Box>
      </Box>
    </CellContainer>
  );
}
